
const _ = require('lodash');
const cookies = require('js-cookie');


module.exports = function myRgsCleanupCookies () {
	_.each(cookies.get(), function (value, name) {
		if (/^Rgs\.My\./.test(name) || /^Rgs\.Calcs\.Osago2\./.test(name)) {
			cookies.remove(name, { path: '/' });
		}
	});
};


